export default __webpack_public_path__ + "static/media/applications-image-14.2432e79c.jpg";